import { SearchOutlined } from '@ant-design/icons';
import BookCover from "@components/book-cover";
import { SearchSubmitIcon } from "@components/icons/HomePageIcons";
import { DollarIcon } from "@components/icons/Icons";
import { getWordpressUrl } from "@lib/wordpressVars";
import { useGetIssuesHomepageMarketplaceQuery } from "@mwServices/Issue";
import { Button, Col, Input, Row } from "antd";
import { useEffect, useMemo, useState } from "react";

import marketplace_bg_img from "./marketplace_bg.png";

const HomePageMarketplace = ({windowDimensions, onLoad}) => {
    const marketQuery = useGetIssuesHomepageMarketplaceQuery({show_totals: true});
    const [searchValue, setSearchValue] = useState('');

    const smallScreen = useMemo(() => {
        return windowDimensions.under(1200);
    }, [windowDimensions]);

    useEffect(() => {
        if(marketQuery.data) onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [marketQuery]);

    const issues = useMemo(() => {
        if(marketQuery.data && marketQuery.data.issues) {
            if(windowDimensions.over(799)) {
                return marketQuery.data.issues.slice(0);
            } else {
                return marketQuery.data.issues.slice(0,6);
            }
        }
        return [];
    }, [marketQuery, windowDimensions]);

    const gotoMarketplace = () => {
        const search = searchValue.split('#');
        console.log('searchValue', searchValue);
        if(search.length === 2) {
            window.location.href = `/marketplace/?search=${search[0].trim()}&search_issue=${search[1]}`;
        } else {
            window.location.href = `/marketplace/?search=${search[0].trim()}`;
        }
    };

    return (
        <div className="homepage-market covr-contain pad-top-20 pad-bot-20">
            <h2 >Find Comics To Buy</h2>

            <Row className="top-box flex-align-center flex-vertical-center" style={{
                background: `url(${getWordpressUrl(marketplace_bg_img)}) no-repeat center center`,
            }}>
                <div className="top-box-content">
                    <p className="top-title">Comic Shopping Hub</p>
                    <p className="top-subitle">Search for comics across multiple 3rd-Party marketplaces for deals and more</p>

                    <Row className={"width-100"}>
                        <Col span={!smallScreen ? 6 : 2} className="flex-vertical-center flex-align-center">
                        </Col>
                        <Col span={!smallScreen ? 12 : 18} className="homepage_search_info flex-vertical-center flex-align-center">
                            <Input
                                name="search"
                                type="text"
                                placeholder="e.g. Amazing Spider-Man #300"
                                prefix={<SearchOutlined className={"iconGrey"} />}
                                className="search_input"
                                onKeyPress={(event) => {
                                    if(event.key === 'Enter') {
                                        gotoMarketplace();
                                    }
                                }}
                                value={searchValue}
                                onChange={(event) => { setSearchValue(event.target.value) }}
                            />
                        </Col>
                        <Col span={!smallScreen ? 2 : 3} className="flex-vertical-center flex-align-center">
                            <button type={"submit"} className={"search-submit-button"} onClick={(event) =>  {
                                event.preventDefault();
                                gotoMarketplace();
                            }}>
                                <SearchSubmitIcon/>
                            </button>
                        </Col>
                    </Row>

                </div>
            </Row>

            {issues && (<>
                <div className="market-grid">
                    {issues.map((issue,i) => (
                        <div key={i} className="market-item">
                            <a href={`/marketplace/?issue_id=${issue.id}`}>
                                <BookCover issue={issue} preview={false}/>
                            </a>
                            <div className={"homepage-item-title mar-top-5"}>{issue.series_title}</div>
                            <div className={"homepage-item-subtitle"}>{issue.issue_number}</div>
                            <DollarIcon className={"whiteCircleIconTiny"} style={{position: 'absolute', top: 10, right: issue.is_variant ? 35 : 10}}/>
                        </div>
                    ))}
                </div>
                <Row justify="center" className="mar-top-15 mar-bot-15">
                    <Button className="homepage-section-big-button" href="/marketplace">Go to Marketplace</Button>
                </Row>
            </>)}
        </div>
    );
};

export default HomePageMarketplace;